var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 14,
    viewBox: "0 0 40 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1H10C10.5523 1 11 1.44772 11 2V12C11 12.5523 10.5523 13 10 13H3",
    stroke: "#313132",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13H30C29.4477 13 29 12.5523 29 12V2C29 1.44772 29.4477 1 30 1H37",
    stroke: "#313132",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H29",
    stroke: "#313132",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H29",
    stroke: "#313132",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.5L13.1056 7.55279C13.6686 7.83431 14.3314 7.83431 14.8944 7.55279L16.259 6.87048C16.7335 6.63327 17.2827 6.59423 17.7859 6.76197L19.3675 7.28918C19.7781 7.42603 20.2219 7.42603 20.6325 7.28918L22.3675 6.71082C22.7781 6.57397 23.2219 6.57397 23.6325 6.71082L25.3675 7.28918C25.7781 7.42603 26.2219 7.42603 26.6325 7.28918L29 6.5",
    stroke: "#313132",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 1V1C1.89543 1 1 1.89543 1 3V11C1 12.1046 1.89543 13 3 13V13",
    stroke: "#313132",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13V13C38.1046 13 39 12.1046 39 11V3C39 1.89543 38.1046 1 37 1V1",
    stroke: "#313132",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuse);
export default __webpack_public_path__ + "static/media/fuse.58a64bbd71097adc08da1fe74aa70f48.svg";
export { ForwardRef as ReactComponent };